import { Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import LogIn from "./sharedScreens/auth/login/LogIn";
import Dashboard from "./adminScreens/pages/home/Dashboard";
import CreatePassword from "./screens/CreatePassword";
import ForgotPassword from "./screens/ForgotPassword";
import UserManagement from "./screens/controlPanel/UserManagement";
import RolesAndPermission from "./screens/controlPanel/Permissions";
import UserInfoList from "./screens/controlPanel/UserInfoList";
import FlightList from "./screens/flight/FlightList";

import HotelBooking from "./screens/Hotels/HotelBooking";
import Onboarding from "./screens/Onboarding";
import ProtectedRoute from "./ProtectRoute";
import ManageBooking from "./screens/controlPanel/ManageBooking";
import CorporateList from "./screens/controlPanel/CorporateList";
import CorporateManagement from "./screens/controlPanel/CorporateManagement";
import FlightSearch from "./screens/flight/FlightSearch";
import FlightDetail from "./screens/flight/FlightDetail";
import AncillaryServices from "./screens/controlPanel/AncillaryServices";
import Changepassword from "./screens/Changepassword";
import AgentCreation from "./screens/AgentCreation";
import ROEUpdation from "./screens/ROEUpdation";
import AirlineSegments from "./screens/AirlineSegments";
import Advertisement from "./screens/Advertisement";
import PendingAgentRequest from "./screens/PendingAgentRequest";
import BankDetail from "./screens/BankDetail";
import Ticket from "./screens/Ticket";
import { Alert } from "@mui/material";
import AlertandNotification from "./screens/AlertandNotification";
import IPConfiguration from "./screens/IPConfiguration";
import Notifiy from "./screens/Notifiy";
import ThreadKeyMapping from "./screens/ThreadKeyMapping";
import BookingTrack from "./screens/BookingTrack";
import PaymentTrack from "./screens/PaymentTrack";
import CancelTicket from "./screens/CancelTicket";
import RescheduleTicket from "./screens/RescheduleTicket";
import RetrieveAccounting from "./screens/RetrieveAccounting";
import AirlineBooking from "./screens/AirlineBooking";
import InfantManualBooking from "./screens/InfantManualBooking";
import SSRUpdation from "./screens/SSRUpdation";
import FareRule from "./screens/FareRule";
import ScheduleUpdate from "./screens/ScheduleUpdate";
import PGTrackStatus from "./screens/PGTrackStatus";
import TripBookingRequest from "./screens/TripBookingRequest";
import InsurancePlan from "./screens/InsurancePlan";
import ERPStatus from "./screens/ERPStatus";
import AirlineDSRUpload from "./screens/AirlineDSRUpload";
import PassengerProfile from "./screens/PassengerProfile";
import MobilePushNotification from "./screens/MobilePushNotification";
import HotelManualBooking from "./screens/HotelManualBooking";
import VisaCreate from "./screens/VisaCreate";
import VisaHistory from "./screens/VisaHistory";
import UnpurgePNR from "./screens/UnpurgePNR";
import InsurancePlanMapping from "./screens/InsurancePlanMapping";
import BookVisa from "./screens/visa/BookVisa";
import VisaManageBooking from "./screens/visa/VisaManageBooking";
import HotelList from "./screens/Hotels/HotelList";
import DebitEntry from "./screens/fund/Credit/DebitEntry";
import CreditControl from "./screens/visa/CreditControl";
import UpdateCustomerBalance from "./screens/fund/Credit/UpdateCustomerBalance";
import UpdateTopupRequest from "./screens/fund/Credit/UpdateTopupRequest";
import VendorBalance from "./screens/fund/Credit/VendorBalance";
import EasyPayment from "./screens/fund/Credit/EasyPayment";
import FlightBookingHistory from "./screens/flight/FlightBookingHistory";
import FlightBookingHistoryDetail from "./screens/flight/FlightBooking/FlightBookingHistoryDetail";
import DabitBalance from "./screens/fund/Credit/DabitBalance";
import HotelListDetail from "./screens/Hotels/HotelListDetail";
import Terms from "./screens/controlPanel/Terms";
import Suppliers from "./screens/Suppliers";
import VoucherCode from "./screens/businessEntry/VoucherCode";
import PGCharges from "./screens/businessEntry/PGCharges";
import ViewSupplierCommission from "./screens/businessEntry/ViewSupplierCommission";
import HotelRoomDetail from "./screens/Hotels/HotelRoomDetail";
import AssignCommission from "./screens/businessEntry/AssignCommission";
import HotelBookingDetail from "./screens/Hotels/HotelBookingDetail";
import CodeConfig from "./screens/businessEntry/CodeConfig";
import AirlineMapping from "./screens/businessEntry/AirlineMapping";
import Fop from "./screens/businessEntry/Fop";
import AirlineBaggage from "./screens/businessEntry/AirlineBaggage";
import AirlinePenaltyCharges from "./screens/businessEntry/AirlinePenaltyCharges";
import FlightSchedule from "./screens/businessEntry/inventory/FlightSchedule";
import FareView from "./screens/businessEntry/inventory/FareView";
import StockReport from "./screens/businessEntry/inventory/StockReport";
import SalesReport from "./screens/businessEntry/inventory/SalesReport";
import OfflineTicketAccounting from "./screens/businessEntry/inventory/OfflineTicketAccounting";
import OfflineInventorySummary from "./screens/businessEntry/inventory/OfflineInventorySummary";
import GSTDetails from "./screens/GSTDetails";
import CustomerTransactionDetails from "./screens/reports/CustomerTransactionDetails";
import UpdateAgencyBalance from "./screens/reports/UpdateAgencyBalance";
import PNRWiseSales from "./screens/reports/PNRWiseSales";
import AgentProductiveAnalysis from "./screens/reports/AgentProductiveAnalysis";
import CashPaymentDetails from "./screens/reports/CashPaymentDetails";
import MonthlyTicketCount from "./screens/reports/MonthlyTicketCount";
import DailyTicketCount from "./screens/reports/DailyTicketCount";
import AgencyList from "./screens/reports/AgencyList";
import SalesSummary from "./screens/reports/SalesSummary";
import SalesVolumeAirlineWise from "./screens/reports/SalesVolumeAirlineWise";
import TopupReport from "./screens/reports/TopupReport";
import StaffWiseSales from "./screens/reports/StaffWiseSales";
import MySales from "./screens/reports/MySales";
import ShadowBalanceOutstanding from "./screens/reports/ShadowBalanceOutstanding";
import DaywiseAgentBalance from "./screens/reports/DaywiseAgentBalance";
import DaywiseCustomerOpeningBalance from "./screens/reports/DaywiseCustomerOpeningBalance";
import PNRRemarksReport from "./screens/reports/PNRRemarksReport";
import OfflinePNRReport from "./screens/reports/OfflinePNRReport";
import FlightSeriesCalendar from "./screens/reports/FlightSeriesCalendar";
import CreditDebitTransaction from "./screens/reports/CreditDebitTransaction";
import PNRTransactionHistory from "./screens/reports/PNRTransactionHistory";
import SavingsReport from "./screens/reports/SavingsReport";
import ConsolidateSales from "./screens/reports/ConsolidateSales";
import CustomerDepositDetails from "./screens/reports/CustomerDepositDetails";
import Policywisesales from "./screens/reports/Policywisesales";
import OutStandingReport from "./screens/reports/OutStandingReport";
import AgentInvoiceDetailsReport from "./screens/reports/AgentInvoiceDetailsReport";
import DIConsolidateReport from "./screens/reports/DIConsolidateReport";
import NoShowReport from "./screens/reports/NoShowReport";
import TicketReconciliation from "./screens/reports/TicketReconciliation";
import CreditInfo from "./screens/reports/CreditInfo";
import SupplierCommissionDetails from "./screens/reports/SupplierCommissionDetails";
import L2BDetail from "./screens/reports/L2BDetail";
import DetailedTransaction from "./screens/reports/DetailedTransaction";
import CancelReschduleRequest from "./screens/reports/CancelReschduleRequest";
import DistributorLedger from "./screens/reports/DistributorLedger";
import AgentDetails from "./screens/reports/AgentDetails";
import MarkupDetails from "./screens/reports/Service Fee/MarkupDetails";
import CommissionDetails from "./screens/reports/CommissionDetails";
import InvoiceDetail from "./screens/reports/InvoiceDetail";
import FareTrendDetails from "./screens/reports/FareTrendDetails";
import MisSalesAnalysis from "./screens/reports/MisSalesAnalysis";
import CustomerManagement from "./screens/CustomerManagement";
import PendingCustomerRequest from "./screens/PendingCustomerRequest";
import AddGSTDetails from "./screens/AddGSTDetails";
import AddBankDetails from "./screens/AddBankDetails";
import NoticeBoard from "./screens/NoticeBoard";
import HotelBookingHistoryDetail from "./screens/Hotels/HotelBookingHistoryDetail";
import HotelBookingHistory from "./screens/Hotels/HotelBookingHistory";
import FlightBookingConfirmation from "./screens/successPage/FlightBookingConfirmation";
import HotelBookingConfirmation from "./screens/successPage/HotelBookingConfirmation";
import AdminConfiguration from "./screens/controlPanel/AdminConfiguration";
import { GlobalProvider, useGlobalState } from "./services/context/AuthContext";
import HotelCommission from "./screens/businessEntry/HotelCommission";
import PageNotFound from "./components/composite/notFound/PageNotFound";
import {
  conditionalCodes,
  impliedPermissions,
  MENU_CONFIG,
} from "./constants/menuItem";
import PermissionGuard from "./PermissionGaurd";
import { extractAllowedCodes } from "./constants/helper";
import TopUpRequest from "./screens/fund/Credit/TopUpRequest";
import FlightRating from "./screens/controlPanel/ThrottleManagement";
import AdminUserManagement from "./screens/controlPanel/AdminUserManagement";
import CorporatePostpaidAccount from "./screens/fund/Credit/CorporatePostpaidAccount";
import FlightRoundTripList from "./screens/flight/IntlRTFLightListCard";
import PaymentCard from "./screens/businessEntry/PaymentCard";

// Create a default theme
const theme = createTheme();

export default function App() {
  const { permission } = useGlobalState();
  const allowedCodes = extractAllowedCodes(
    permission || [],
    impliedPermissions,
    conditionalCodes
  );
  const extractRoutes = (items: any[], allowedCodes: string[]) => {
    const routes: JSX.Element[] = [];

    for (const item of items) {
      if (item.children) {
        routes.push(...extractRoutes(item.children, allowedCodes));
      }

      if (item.path && item.element && allowedCodes.includes(item.code)) {
        routes.push(
          <Route
            key={item.path}
            path={item.path}
            element={
              <PermissionGuard code={item.code}>{item.element}</PermissionGuard>
            }
          />
        );
      }
    }

    return routes;
  };
  return (
    <ThemeProvider theme={theme}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LogIn />} />
        <Route path="onboarding" element={<Onboarding />} />
        <Route path="createpassword" element={<CreatePassword />} />
        <Route path="forgotpassword" element={<ForgotPassword />} />
        <Route path="pagenotfound" element={<PageNotFound />} />
        {/* Protected Routes (Only accessible if user has permission) */}
        <Route element={<ProtectedRoute />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="corporatelist" element={<CorporateList />} />
          <Route path="termsandcondition" element={<Terms />} />
          <Route path="assigncommission" element={<AssignCommission />} />
          <Route path="hotelcommission" element={<HotelCommission />} />
          <Route path="changepassword" element={<Changepassword />} />
          <Route path="usermanagement" element={<UserManagement />} />

          {/* flights */}
          <Route path="flightlist" element={<FlightList />} />
          <Route path="flightDetail" element={<FlightDetail />} />
          <Route
            path="flightbookingconfirmation"
            element={<FlightBookingConfirmation />}
          />
          <Route
            path="flightbookinghistory"
            element={<FlightBookingHistory />}
          />
          <Route
            path="flightbookinghistorydetail"
            element={<FlightBookingHistoryDetail />}
          />
          <Route path="throttlemanagement" element={<FlightRating />} />

          {/* control-pannel */}
          <Route path="suppliermanagement" element={<Suppliers />} />
          <Route path="UpdateTopupRequest" element={<UpdateTopupRequest />} />
          <Route path="agentcreation" element={<AgentCreation />} />
          <Route path="customermanagement" element={<CustomerManagement />} />
          <Route path="corporatemanagement" element={<CorporateManagement />} />

          <Route path="gstdetails" element={<GSTDetails />} />

          <Route
            path="pendingcustomerrequest"
            element={<PendingCustomerRequest />}
          />
          <Route path="bankdetail" element={<BankDetail />} />
          <Route path="Pendingagentrequest" element={<PendingAgentRequest />} />
          <Route path="addgstdetails" element={<AddGSTDetails />} />
          <Route path="addbankdetails" element={<AddBankDetails />} />
          <Route path="threadkeymapping" element={<ThreadKeyMapping />} />
          <Route path="ticket" element={<Ticket />} />
          <Route path="ipconfiguration" element={<IPConfiguration />} />
          <Route path="alertnotifiation" element={<AlertandNotification />} />

          <Route path="notifiy" element={<Notifiy />} />
          <Route path="adminusermanagement" element={<AdminUserManagement />} />
          <Route path="advertisement" element={<Advertisement />} />
          {/* Action */}
          <Route path="cancelticket" element={<CancelTicket />} />
          <Route path="rescheduleticket" element={<RescheduleTicket />} />
          <Route path="airlinebooking" element={<AirlineBooking />} />

          <Route path="hotelmanualbooking" element={<HotelManualBooking />} />
          <Route path="farerule" element={<FareRule />} />
          <Route path="pgtrackStatus" element={<PGTrackStatus />} />
          <Route path="tripbookingrequest" element={<TripBookingRequest />} />
          <Route path="insuranceplan" element={<InsurancePlan />} />
          <Route
            path="insuranceplanmapping"
            element={<InsurancePlanMapping />}
          />
          <Route path="erpstatus" element={<ERPStatus />} />
          <Route path="airlinedsrUpload" element={<AirlineDSRUpload />} />
          <Route path="Passengerprofile" element={<PassengerProfile />} />
          <Route path="adminconfiguration" element={<AdminConfiguration />} />
          <Route
            path="mobilepushnotification"
            element={<MobilePushNotification />}
          />

          <Route path="VisaCreate" element={<VisaCreate />} />
          <Route path="visahistory" element={<VisaHistory />} />
          <Route path="unpurgepnr" element={<UnpurgePNR />} />

          {/* reports */}
          <Route
            path="customertransactiondetails"
            element={<CustomerTransactionDetails />}
          />
          <Route path="updateagencybalance" element={<UpdateAgencyBalance />} />
          <Route
            path="agentproductiveanalysis"
            element={<AgentProductiveAnalysis />}
          />
          <Route path="cashpaymentdetails" element={<CashPaymentDetails />} />
          <Route path="dailyticketcount" element={<DailyTicketCount />} />
          <Route path="agencylist" element={<AgencyList />} />
          <Route path="salessummary" element={<SalesSummary />} />
          <Route
            path="salesvolumeairlinewise"
            element={<SalesVolumeAirlineWise />}
          />
          <Route path="topupreport" element={<TopupReport />} />
          <Route path="staffwisesales" element={<StaffWiseSales />} />
          <Route path="mysales" element={<MySales />} />
          <Route
            path="shadowbalanceoutstanding"
            element={<ShadowBalanceOutstanding />}
          />
          <Route
            path="daywisecustomerOpeningbalance"
            element={<DaywiseCustomerOpeningBalance />}
          />
          <Route path="pnrremarksreport" element={<PNRRemarksReport />} />
          <Route path="OfflinePNRReport" element={<OfflinePNRReport />} />
          <Route
            path="flightseriescalendar"
            element={<FlightSeriesCalendar />}
          />
          <Route
            path="creditdebittransaction"
            element={<CreditDebitTransaction />}
          />
          <Route
            path="pnrtransactionhistory"
            element={<PNRTransactionHistory />}
          />
          <Route
            path="customerdepositdetails"
            element={<CustomerDepositDetails />}
          />
          <Route path="policywisesales" element={<Policywisesales />} />
          <Route path="outstandingreport" element={<OutStandingReport />} />
          <Route
            path="agentinvoicedetailsreport"
            element={<AgentInvoiceDetailsReport />}
          />
          <Route path="diconsolidatereport" element={<DIConsolidateReport />} />
          <Route path="NoShowReport" element={<NoShowReport />} />
          <Route
            path="ticketreconciliation"
            element={<TicketReconciliation />}
          />
          <Route path="creditInfo" element={<CreditInfo />} />
          <Route
            path="suppliercommissionDetails"
            element={<SupplierCommissionDetails />}
          />
          <Route path="l2bdetail" element={<L2BDetail />} />
          <Route
            path="cancelreschdulerequest"
            element={<CancelReschduleRequest />}
          />
          <Route path="distributorledger" element={<DistributorLedger />} />
          <Route path="agentdetails" element={<AgentDetails />} />
          <Route path="markupdetails" element={<MarkupDetails />} />
          <Route path="commissiondetails" element={<CommissionDetails />} />
          <Route path="invoicedetail" element={<InvoiceDetail />} />
          <Route path="faretrenddetails" element={<FareTrendDetails />} />
          <Route path="missalesanalysis" element={<MisSalesAnalysis />} />

          {/* Business-entry */}
          <Route path="fop" element={<Fop />} />
          <Route path="pgcharges" element={<PGCharges />} />
          {/* Inventory */}
          {/* ------------------------------------ */}
          <Route path="flightschedule" element={<FlightSchedule />} />
          <Route path="fareview" element={<FareView />} />
          <Route path="stockreport" element={<StockReport />} />
          <Route path="salesreport" element={<SalesReport />} />
          <Route
            path="offlineticketaccounting"
            element={<OfflineTicketAccounting />}
          />
          <Route
            path="offlineinventorysummary"
            element={<OfflineInventorySummary />}
          />
          <Route
            path="airlinepenaltycharges"
            element={<AirlinePenaltyCharges />}
          />
          <Route path="commissionmarkup" element={<ViewSupplierCommission />} />
          <Route path="vouchercsode" element={<VoucherCode />} />
          <Route path="paymentcard" element={<PaymentCard />} />
          {/* Visa */}
          <Route path="visasearch" element={<BookVisa />} />
          <Route path="visamanagebooking" element={<VisaManageBooking />} />

          {/* Fund */}
          <Route path="topuprequest" element={<TopUpRequest />} />
          <Route path="creditcontrol" element={<CreditControl />} />
          <Route path="easypayment" element={<EasyPayment />} />

          {/* Hotels */}
          <Route path="hotellist" element={<HotelList />} />
          <Route path="hotellistdetail" element={<HotelListDetail />} />
          <Route path="hotelroomdetail" element={<HotelRoomDetail />} />
          {/* hotelbookingdetail //TODO:this file is not in work , need to ask from suraj to remove this file */}
          <Route path="hotelbookingdetail" element={<HotelBookingDetail />} />

          <Route
            path="HotelBookingHistoryDetail"
            element={<HotelBookingHistoryDetail />}
          />
          <Route
            path="hotelbookingconfirmation"
            element={<HotelBookingConfirmation />}
          />
          <Route
            path="corporatepostpaidaccount"
            element={<CorporatePostpaidAccount />}
          />

          <Route path="userinfolist" element={<UserInfoList />} />
          {/* Permission based protected Route */}
          {extractRoutes(MENU_CONFIG, allowedCodes)}
        </Route>
        {/* Redirect unknown routes to login */}
        <Route path="*" element={<LogIn />} />
      </Routes>
    </ThemeProvider>
  );
}
